import { type CookieRegistry } from '@/constants/cookieRegistry'

export const deleteCookie = (key: CookieRegistry, domain: string = '') => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`
}
